import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getNotificationCountSince } from '../services/api';
import './Navbar.css';

const LAST_SEEN_KEY = 'notificationsLastSeen';

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [newCount, setNewCount] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    const lastSeen = localStorage.getItem(LAST_SEEN_KEY) || new Date(0).toISOString();
    getNotificationCountSince(lastSeen)
      .then(res => setNewCount(res.data.data.count))
      .catch(() => {});
  }, [user, location.pathname]);

  useEffect(() => {
    if (location.pathname === '/notifications') {
      localStorage.setItem(LAST_SEEN_KEY, new Date().toISOString());
      setNewCount(0);
    }
  }, [location.pathname]);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const handleLogout = () => { logout(); navigate('/goodbye'); };
  const isActive = (path) => location.pathname === path;

  return (
    <>
      <div className="dt-chrome">
        <div className="dt-utility">
          <span>PRICEHUNTIFY · price tracker for Amazon</span>
          <span className="dt-utility-right">
            <span className="dt-live">● LIVE</span>
          </span>
        </div>

        <header className="dt-header">
          <div className="dt-brand">
            <Link to="/dashboard" className="dt-wordmark">
              Pricehuntify<span className="dt-dot">.</span>
            </Link>
            <span className="dt-console">// your console</span>
          </div>

          <button
            className={`dt-hamburger${menuOpen ? ' is-open' : ''}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <span /><span /><span />
          </button>

          <nav className={`dt-nav${menuOpen ? ' is-open' : ''}`}>
            <Link to="/dashboard" className={`dt-navlink${isActive('/dashboard') ? ' is-active' : ''}`}>
              Dashboard
            </Link>
            <Link to="/notifications" className={`dt-navlink${isActive('/notifications') ? ' is-active' : ''}`}>
              Notifications
              {newCount > 0 && (
                <span className="dt-badge">{newCount > 99 ? '99+' : newCount}</span>
              )}
            </Link>
            <Link to="/profile" className={`dt-navlink${isActive('/profile') ? ' is-active' : ''}`}>
              Profile
            </Link>
            {user?.isAdmin && (
              <Link to="/admin" className={`dt-navlink dt-navlink-admin${isActive('/admin') ? ' is-active' : ''}`}>
                Admin
              </Link>
            )}
            <Link to="/feedback" className={`dt-navlink dt-navlink-feedback${isActive('/feedback') ? ' is-active' : ''}`}>
              Feedback
            </Link>
            <span className="dt-nav-email">· {user?.name || user?.email}</span>
            <button className="dt-navlink dt-signout" onClick={handleLogout}>
              Logout
            </button>
          </nav>
        </header>
      </div>

    </>
  );
}

export default Navbar;
